<template>
  <div>
    <a-tabs :active-key="activeKey" @change="changeTab">
      <a-tab-pane
        v-for="item in tabs"
        :key="item.routeName"
        :tab="item.tabName"
      >
        <router-view v-if="activeKey === item.routeName" />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
export default {
  name: 'FinanceLedgerShowTab',
  data() {
    return {
      activeKey: '',
      tabs: [
        { routeName: 'finance_ledger_transfers', tabName: '收付款记录' },
        { routeName: 'finance_ledger_open_channel_payments', tabName: '开放渠道支付' }
      ]
    }
  },
  watch: {
    $route: {
      handler(route) {
        this.activeKey = route.name
      }
    }
  },
  created() {
    this.activeKey = this.$route.name
  },
  methods: {
    changeTab(activeKey) {
      this.activeKey = activeKey
      this.$router.push({ name: activeKey })
    }
  }
}
</script>
